import React from 'react';
import { observer } from 'mobx-react';
import MarkdownContent from './MarkdownContent';
import { Card, CardTitle, Badge, EmptyState } from './CompanyPage.styles';

const ProspectProfileView = observer(({ profiles }) => {
  // Handle both array and single object (MobX model can be either)
  const profileList = Array.isArray(profiles) ? profiles : profiles ? [profiles] : [];

  if (profileList.length === 0) {
    return <EmptyState>No prospect profiles have been added yet.</EmptyState>;
  }

  return (
    <>
      {profileList.map((profile, i) => (
        <Card key={i}>
          <CardTitle>
            {profile.industry || `Prospect Profile #${i + 1}`}
          </CardTitle>
          <MarkdownContent markdown={profile.specificCharacteristics} />
        </Card>
      ))}
    </>
  );
});

export default ProspectProfileView;
